import { HcLazyload } from '@iris.interactive/handcook/public/scripts/components/lazyload/lazyload.component'
import Swiper from '@iris.interactive/handcook/public/scripts/libraries/swiper-11'

import Rellax from 'rellax/rellax'

export default class HomeService {
    constructor() {
        HomeService.strateCampagnes().then(() => {
            HomeService.strateSejours().then(() => {
                HomeService.strateExperiences()
                HomeService.parallax()
                HomeService.headerHomeLoading()
                HomeService.scrollReveal()
            })
        })
    }

    static async strateCampagnes() {
        const element = $("div[data-swiper='home-campagnes-swiper']")
        if (element.length && !$('body').hasClass('eco-mode-active')) {
            const swiperKey = 'home-campagnes-swiper'
            const slideItem = `[data-swiper="${swiperKey}"] > .block__campagne`

            const options = {
                mousewheel: {
                    forceToAxis: true,
                },
                slidesPerView: 1,
                spaceBetween: 10,
                speed: 2000,
                navigation: {
                    nextEl: `#swiper-${swiperKey}-next`,
                    prevEl: `#swiper-${swiperKey}-prev`,
                },
                keyboard: true,
                loop: false,
                freeMode: {
                    enabled: true,
                },
                freeModeFluid: true,
                passiveListeners: false,
                watchSlidesVisibility: true,
                breakpoints: {
                    600: {
                        slidesPerView: 1,
                        spaceBetween: 20,
                    },
                    1000: {
                        slidesPerView: 1,
                        spaceBetween: 40,
                    },
                },
            }

            $(slideItem).wrapAll('<div class="swiper-wrapper"></div>').addClass('swiper-slide')

            await Swiper.create(`[data-swiper="${swiperKey}"]`, options)
        }
    }

    static async strateSejours() {
        await HomeService.buildSejoursSwiper()
        if (window.matchMedia('(max-width: 1000px)').matches) {
            HomeService.dropdownCategoriesMobile()
        }

        $('[data-trigger="sejour-category"]').on('click', function () {
            $('[data-trigger="sejour-category"]').removeClass('active')
            $(this).addClass('active')

            const loader = $('.strate-sejours__list .loader')
            $('.strate-sejours__list').css('overflow', 'hidden')
            loader.show()

            const categoryId = $(this).data('filter')

            $.ajax({
                url: IRISCollectionTheme.ajaxUrl,
                data: {
                    action: 'get_trips_by_category',
                    datas: {
                        category_id: categoryId,
                        ecoMode: IRISCollectionTheme.config.ecomodeActive,
                    },
                },
                method: 'POST',
            }).done(async (response) => {
                $('[data-element="trips-swiper-container"]').html(response)
                HcLazyload.update()
                if (!$('body').hasClass('eco-mode-active')) {
                    await HomeService.buildSejoursSwiper()
                }
                $('[data-element="button_category"]').removeClass('active')
                $(`[data-button-category-id="${categoryId}"]`).addClass('active')
                $('.strate-sejours__list').css('overflow', 'visible')
                loader.hide()
            })
        })
    }

    static strateExperiences() {
        const element = $('.strate-experiences')
        if (element.length > 0 && !element.is(':hidden')) {
            // background height
            const heightBackground = $('.strate-experiences-background').height()
            const heightContent = $('.strate-experiences-content').height()
            if (heightContent > heightBackground) {
                if (window.matchMedia('(max-width: 1000px)').matches) {
                    $('.strate-experiences-background').height(heightContent + 120)
                } else {
                    $('.strate-experiences-background').height(heightContent + 40)
                }
            }

            // video loading
            const videoElement = $('video[data-element="experiences-videos"]')
            if (
                window.matchMedia('(min-width: 1000px)').matches &&
                !$('body').hasClass('has-eco-mode')
            ) {
                HomeService.addSourceToVideo(videoElement, videoElement.data('desktop-vid'))
                $('.strate-experiences-background picture').remove()
            } else {
                videoElement.remove()
            }
        }
    }

    static addSourceToVideo(element, src) {
        const source = document.createElement('source')
        source.src = src
        source.type = 'video/mp4'
        element.append(source)
    }

    static async buildSejoursSwiper() {
        const element = $('[data-element="trips-swiper-container"]')
        if (element.length && !element.is(':hidden') && !$('body').hasClass('eco-mode-active')) {
            const swiperKey = 'home-sejours-swiper'
            const slideItem = `[data-swiper="${swiperKey}"] > .card-sejour__item`

            const options = {
                mousewheel: {
                    forceToAxis: true,
                },
                slidesPerView: 1,
                spaceBetween: 10,
                speed: 1000,
                navigation: {
                    nextEl: `#swiper-${swiperKey}-next`,
                    prevEl: `#swiper-${swiperKey}-prev`,
                },
                keyboard: true,
                loop: false,
                freeMode: {
                    enabled: true,
                },
                freeModeFluid: true,
                passiveListeners: false,
                watchSlidesVisibility: true,
                breakpoints: {
                    600: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                    1000: {
                        slidesPerView: 2,
                        spaceBetween: 40,
                    },
                },
            }

            $(slideItem).wrapAll('<div class="swiper-wrapper"></div>').addClass('swiper-slide')

            await Swiper.create(`[data-swiper="${swiperKey}"]`, options)
        }
    }

    static dropdownCategoriesMobile() {
        $('[data-trigger="category-dropdown-mobile"]').on('click', function () {
            $(this).toggleClass('open')
            $('.sejours_categories_list').toggleClass('open')
        })
        $('[data-trigger="sejour-category"]').on('click', function () {
            const currentLabel = $(this).text()
            $('[data-trigger="category-dropdown-mobile"]').html(currentLabel).removeClass('open')
            $('.sejours_categories_list').removeClass('open')
        })
    }

    static parallax() {
        const element = $('.home')
        if (
            element.length > 0 &&
            !element.is(':hidden') &&
            !$('body').hasClass('eco-mode-active') &&
            window.matchMedia('(min-width: 1000px)').matches
        ) {
            new Rellax('.rellax')
        }
    }

    static headerHomeLoading() {
        if (
            !$('body').hasClass('eco-mode-active') &&
            $('body').hasClass('home') &&
            window.matchMedia('(min-width: 1000px)').matches
        ) {
            $('body').removeClass('hp-reveal-loading')
        }
    }

    static scrollReveal() {
        const ratio = 0.1
        const options = {
            root: null,
            rootMargin: '0px',
            threshold: 0.1,
        }

        const handleIntersect = (entries, observer) => {
            for (const entry of entries) {
                if (entry.intersectionRatio >= ratio) {
                    entry.target.classList.remove('reveal')
                    observer.unobserve(entry.target)
                }
            }
        }

        if (!$('body').hasClass('eco-mode-active')) {
            document.documentElement.classList.add('reveal-loaded')
            if (!window.matchMedia('(max-width: 1000px)').matches) {
                const observer = new IntersectionObserver(handleIntersect, options)
                for (const element of document.querySelectorAll('.reveal')) {
                    observer.observe(element)
                }
            } else {
                for (let i = 1; i <= 10; i++) {
                    for (const element of document.querySelectorAll(`.reveal-${i}`)) {
                        element.classList.remove(`reveal-${i}`)
                    }
                }
            }
        }
    }
}
